<template>
	<el-row>
		<el-row style="margin-bottom: 20px;">
			<el-col :span="4">
				<div class="search-view">
					<div>课程分类:</div>
					<el-cascader size="mini" class="margin-left-10 input" v-model="lessonCategory" :options="options2"
						:props="cateListProps" clearable />
				</div>
			</el-col>
			<el-col :span="7">
				<div class="search-view">
					<div>课程名称:</div>
					<el-input size="mini" placeholder="课程名称" v-model="lessonName"></el-input>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="shuaixuan">筛选</el-button>
					<el-button type="warning" size="mini" style="margin-left: 10px;" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableDate">
			<el-table-column label="序号" prop="courseId"></el-table-column>
			<el-table-column label="课程名称" prop="lessonName"></el-table-column>
			<el-table-column label="所属分类" prop="lessonCategoryName"></el-table-column>
			<el-table-column label="是否收费" prop="free">
				<template slot-scope="scope">
					<span v-if="scope.row.free == 0">免费</span>
					<span v-if="scope.row.free == 1">付费</span>
				</template>
			</el-table-column>
			<el-table-column label="状态" prop="courseStatus">
				<template slot-scope="scope">
					<span v-if="scope.row.courseStatus == 0">上架</span>
					<span v-if="scope.row.courseStatus == 1" style="color: red;">下架</span>
				</template>
			</el-table-column>
			<el-table-column label="原价" prop="price"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<span v-if="scope.row.columnId">已选择</span>
					<el-button v-else type="infor" @click="isXuanze(scope.row)" size="mini"
						style="border:1px solid #00cc33;color: #00cc33;">选择</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="25%" center>
			<el-form ref="info" :model="info" label-position="right" label-width="80px">
				<el-form-item label="关联栏目" prop="columnId" :rules="[
                  { required: true, message: '请选择关联栏目', trigger: 'blur' }
                ]">
					<el-select size="mini" v-model="info.columnId" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="排序" prop="sort" :rules="[
                  { required: true, message: '请输入排序', trigger: 'blur' }
                ]">
					<el-input-number v-model="info.sort" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='queren'>确认</el-button>
					<el-button type="infor" @click="centerDialogVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				lessonName: '',
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100],
				lessonCategory: [],
				lessonCategoryOne: '',
				lessonCategoryTwo: '',
				title: "",
				centerDialogVisible: false,
				value: [],
				options: [],
				options2: [],
				tableDate: [],
				info: {
					sort: "",
					columnId: "",
					courseId: ''
				},
				cateListProps: {
					value: "dicId", //匹配响应数据中的id
					label: "dicDesc", //匹配响应数据中的name
					children: "sonDicList", //匹配响应数据中的children
				},
			}
		},
		methods: {
			shuaixuan() {
				this.getInfo()
			},
			zhikong() {
				this.lessonCategory = []
				this.lessonCategoryOne = ''
				this.lessonCategoryTwo = ''
				this.lessonName = ''
				this.getInfo()
			},
			chakan(row) {},
			displayButton(row) {
				console.log(row);
			},
			queren() {
				this.$refs.info.validate((vai) => {
					if (vai) {
						this.$http.post("/api/course/SiteManageController/addAreaByLesson", {
							specialAreaId: (this.$route.query.id) - 0,
							sort: this.info.sort,
							columnId: this.info.columnId,
							courseId: this.info.courseId
						}).then(res => {
							if (res.data.data.status == 0) {
								this.$message.success(res.data.data.data)
								this.centerDialogVisible = false
								this.getInfo()
							}
						})
					}
				})
			},
			isXuanze(row) {
				this.title = row.title
				this.info.courseId = row.courseId
				this.info.sort = ''
				this.info.columnId = ''
				this.centerDialogVisible = true
			},
			getInfo() {
				if (this.lessonCategory.length > 0) {
					this.lessonCategoryOne = this.lessonCategory[0]
					this.lessonCategoryTwo = this.lessonCategory[1]
				} else {
					this.lessonCategoryOne = ""
					this.lessonCategoryTwo = ""
				}
				this.$http.get(
					`/api/course/SiteManageController/selectAllLesson?lessonName=${this.lessonName}&pageSize=${this.pageSize}&pageNum=${this.pageNum}&lessonCategoryOne=${this.lessonCategoryOne}&lessonCategoryTwo=${this.lessonCategoryTwo}`, {}
				).then(res => {
					// console.log(res.data.data.data.list);
					this.tableDate = res.data.data.data.list
					this.total = res.data.data.data.total
				})
			},
			//获取栏目
			getInfo2() {
				this.$http.get(
					`/api/course/SiteManageController/selectAllColumnByAreaId?areaId=` + this.$route.query.id, {}
				).then(res => {
					// console.log(res.data.data.data);
					res.data.data.data.forEach(i => {
						this.options.push({
							value: i.id,
							label: i.name
						})
					})
				})
			},
			//类别
			getInfo3() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}).then(res => {
					// console.log(res.data.data, "类别");
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options2 = res.data.data
						})
						console.log(this.options2);
					}
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
			this.getInfo2()
			this.getInfo3()
		}
	}
</script>

<style scoped="scoped">
	/deep/.el-input-number__increase {
		right: -38px;
	}
</style>
